<script>

    export let onChange;

    let toggleElem;
    let active = false;

    function toggle() {
        active = !active;
        onChange(active);
    }

</script>

<style>

    .toggle-container {
        background: rgba(0,0,0,0);
        transition: all 0.2s;
        cursor: pointer;
        width: 44px;
        height: 22px;
        margin-left: 12px;
        box-sizing: border-box;
        border: 1px white solid;
        border-radius: 18px;
        display: flex;
        justify-content: center;
    }

    .toggle-container.active {
        background: rgba(0,0,0,1);
        border-color: rgba(1,1,1,0);
    }

    .toggle-container:hover {
        transform: scale(1.08);
    }

    .toggle-slider {
        transition: all .2s ease-in-out;
        transform: translateX(-11px);
        width: 18px;
        height: 18px;
        margin: 1px;
        background: white;
        border-radius: 16px;
    }

    .toggle-slider.active {
        transform: translateX(11px);
    }

</style>

<div on:click={toggle} class:active={active} class="toggle-container">
    <div class="toggle-slider" class:active={active}  bind:this={toggleElem}></div>
</div>